import { ABOUT_AUTHOR } from "@/data/aboutMission";

export const AboutAuthor = () => (
  <section id="author" aria-labelledby="about-author-heading" data-testid="about-author-section" className="scroll-mt-28 border-b border-marian/15">
    <div className="mx-auto max-w-7xl px-4 py-10 sm:px-8 sm:py-12 lg:px-16">
      <h2 id="about-author-heading" data-testid="about-author-heading" className="font-serif text-lg font-semibold text-midnight">About the Author</h2>
      <div className="mt-5 max-w-4xl space-y-4 text-sm leading-7 text-charcoal/90 sm:text-base">
        <p data-testid="about-author-introduction">
          {ABOUT_AUTHOR.introduction}<a href={ABOUT_AUTHOR.ministryUrl} target="_blank" rel="noopener noreferrer" data-testid="about-author-ministry-link" className="font-semibold text-marian underline decoration-gold/60 underline-offset-4 transition-colors hover:text-midnight focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4">{ABOUT_AUTHOR.ministry}</a>. {ABOUT_AUTHOR.description}
        </p>
        <p data-testid="about-author-hope">{ABOUT_AUTHOR.hope}</p>
      </div>
    </div>
  </section>
);